import GreatSchools from '@/components/GreatSchools/GreatSchools';
import PropertyAdditionalDetailsCard from '@/components/PropertyAdditionalDetailsCard/PropertyAdditionalDetailsCard';
import PropertyAddressAndPrice from '@/components/PropertyAddressAndPrice/PropertyAddressAndPrice';
import PropertyCTACard from '@/components/PropertyCTACard/PropertyCTACard';
import PropertyDescriptionCard from '@/components/PropertyDescriptionCard/PropertyDescriptionCard';
import PropertyDetailsPageEmptyState from '@/components/PropertyDetailsPageEmptyState/PropertyDetailsPageEmptyState';
import PropertyFeaturesCard from '@/components/PropertyFeaturesCard/PropertyFeaturesCard';
import PropertyImagesCarousel from '@/components/PropertyImagesCarousel/PropertyImagesCarousel';
import PropertyLocationCard from '@/components/PropertyLocationCard/PropertyLocationCard';
import PropertySpecs from '@/components/PropertySpecs/PropertySpecs';
import SimilarPropertiesSection from '@/components/SimilarPropertiesSection/SimilarPropertiesSection';
import { useAppContext } from '@/contexts/AppContext';
import { useUnit } from '@/hooks/units';
import { getRouteApi } from '@tanstack/react-router';
import Spin from 'antd/es/spin';
import { type FC } from 'react';

const route = getRouteApi('/_layout/units');

const PropertyDetailsPage: FC = () => {
  const { community } = useAppContext();
  const { unitId } = route.useSearch();

  const { data: unit, isFetching: loadingUnit } = useUnit.useSuspenseQuery([community.id, unitId], {
    disabled: !unitId,
  });
  const property = unit?.property;

  if (loadingUnit) {
    return <Spin />;
  }

  if (!property || !unit) {
    return <PropertyDetailsPageEmptyState />;
  }

  return (
    <div className="bg-gray-50">
      <PropertyImagesCarousel images={unit.images} />

      <section className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <PropertyAddressAndPrice property={property} unit={unit} />

          <PropertySpecs unit={unit} />
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-8">
              <PropertyDescriptionCard
                description={property.marketingDescription ?? property.description}
              />
              <PropertyFeaturesCard amenities={unit.amenityNames} />
              <PropertyAdditionalDetailsCard property={property} petPolicy={unit.petPolicy} />
              <PropertyLocationCard property={property} />
              <GreatSchools unitId={unit.id} />
            </div>

            <div className="lg:col-span-1">
              <PropertyCTACard unit={unit} />
            </div>
          </div>
        </div>
      </section>

      <SimilarPropertiesSection unitId={unit.id} />
    </div>
  );
};

export default PropertyDetailsPage;
